$body = $("body");
$(document).on({
    ajaxStart: function() { $body.addClass("loading");    },
    ajaxStop: function() { 
    	setTimeout(function() {
    	$body.removeClass("loading"); 
    	}, 500);
    	setTimeout(function(){
	       	$("div.alert").animate({
			    	opacity: 0, // animate slideUp
			    	marginRight: '-200px'
			  	}, 
			  	'slow', 'linear', function() {
			    	$(this).remove();
			});
	    }, 5000 ); 
    }    
});

/* Check got data existing or not else redirect homepage */
function checkDataToRedirectHome(){
	let check = false;
	var address = $('#checking_variables').attr('data-address');
	var order_type = $('#checking_variables').attr('data-order_type');
	var longitude = $('#checking_variables').attr('data-longitude');
	var latitude = $('#checking_variables').attr('data-latitude');
	var store_code = $('#checking_variables').attr('data-store_code');
	//var delivery_pickup_time = $('#checking_variables').attr('data-delivery_pickup_time');
	if( !address || !order_type || !longitude || !latitude || !store_code ){
		check = true; // change to true to redirect homepage.
	}
	return check;
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

$(function (e) {
	if ($(".alert-success").data( "suggest" ) == "1") {
    	if ($(window).width() < 960) {
    		$('#basket-modal').modal('toggle');
    	}
    }
	/* close alert message after 5 second */
	setTimeout(function(){
      	$("div.alert").animate({
		    	opacity: 0, // animate slideUp
		    	marginRight: '-200px'
		  	}, 
		  	'slow', 'linear', function() {
		    	$(this).remove();
		});
    }, 5000 ); 

    /* activate tooltips */
    $('[data-bs-toggle="tooltip"]').tooltip();

	/* test add dummy cart ajax */
    $('.test-ajax').on('click', function() {
		var r_upgrade = {
			CHZ: {name:'CHEEZE', action: 'remove', price: 25},
			ONION: {name: 'ONION', action: 'add', price: 40}
		};
		var deal_items = [
			{
				sku: 'PZA',
				crust_code: 'PAN',
				size_code: 'PER',
				type: 'PIZZA',
				price: 300,
				qty: 1,
				upgrades: r_upgrade,
				total_price: 40
			}, 
			{
				sku: 'DRK',
				crust_code: '',
				size_code: 'MD',
				type: 'DRINK',
				price: 50,
				qty: 1,
				upgrades: '',
				total_price: 0
			}
		];
		var deal_data = {
			sku: 'DEAL1',
    		crust_code: '',
    		size_code: '',
    		type: 'PROMOTION',
    		price: 800,
    		items: deal_items
		};
		$.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        $.ajax({
        	type: 'POST',
        	url: '/cart/add-dummy-deal',
        	data: deal_data,
        	success: function(data) {
        		$.each(data, function(k, v){
        			console.log(k, v);
        		});
        	}
        });
	});

	/* change language */
    $('body').on('click', '#change_locale_btn', function(e){
        var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
        var lang = $(this).data('locate');
        $.post('/locale/' + lang, {'_token': csrf_token}, function(result) {
            window.location.reload();
        }, "json")
        .fail(function(jqXHR, textStatus, errorThrown) {
            $("#main_content").append('<div class="alert alert-danger">' + jqXHR.responseJSON.meta.message + '</div>');
        });
    });

    /* change hide/show password */
	$('body').on('click', '.input-password-wrap i', function(e){
		var input_hidden_status = $(this).data('hidden');
		if( input_hidden_status != true ){
			$(".input-password-wrap input").attr('type', 'password');
			$(this).data('hidden', true );
			$(this).removeClass('phc-visibility-off');
			$(this).addClass('phc-visibility');
		}else{
			$(".input-password-wrap input").attr('type', 'text');
			$(this).data('hidden', false );
			$(this).removeClass('phc-visibility');
			$(this).addClass('phc-visibility-off');
		}
	});

	/* open quantity modal */
	/*$('body').on('click', '.edit-quantity-modal', function(e){
		var get_cart_id = $(this).attr('data-id');
		var product_name = $(this).attr('data-name');
		var sku = $(this).attr('data-sku');
		var domian_url = $(this).attr('data-domain');
		var qty = $(this).attr('data-quantity');
		$('#quantity_modal #quantity_modal_product_name').html(product_name);
		$('#quantity_modal .control-number input').val(qty);
		$('#quantity_modal .modal-footer .save-button').attr('data-quantity', qty);
		$('#quantity_modal .modal-footer .save-button').attr('data-id', get_cart_id);
		$('#quantity_modal .modal-footer .save-button').attr('data-sku', sku);
		$('#quantity_modal .modal-footer .save-button').attr('data-domain', domian_url);
		if( qty > 1 ){
			$('#quantity_modal .decrement-button').prop("disabled", false);
		}else{
			$('#quantity_modal .decrement-button').prop("disabled", true);
		}
		$('#quantity_modal').modal('show', { keyboard: false, backdrop: 'static' });
	});*/

	/* click increment button */
	/*$('body').on('click', '#quantity_modal .increment-button', function(e){
		var current_qty = $('#quantity_modal .control-number input').val();
		var new_qty = parseInt(current_qty) + 1;
		var max = $('#quantity_modal .control-number input').attr('max');
		var min = $('#quantity_modal .control-number input').attr('min');
		if( new_qty > parseInt(max) || current_qty == parseInt(max)  ){
			$('#quantity_modal .decrement-button').prop("disabled", true);
		}else{
			if( new_qty == parseInt(max) ){
				$('#quantity_modal .decrement-button').prop("disabled", true);
			}else{
				$('#quantity_modal .decrement-button').prop("disabled", false);	
			}
			$('#quantity_modal .control-number input').val(new_qty);
			$('#quantity_modal .modal-footer .save-button').attr('data-quantity', new_qty);
		}
	});*/

	/* click decrement button */
	/*$('body').on('click', '#quantity_modal .decrement-button', function(e){
		var current_qty = $('#quantity_modal .control-number input').val();
		var max = $('#quantity_modal .control-number input').attr('max');
		var min = $('#quantity_modal .control-number input').attr('min');
		var new_qty = parseInt(current_qty) - 1;
		if( new_qty < parseInt(min) || current_qty == parseInt(min) ){
			$('#quantity_modal .decrement-button').prop("disabled", true);
		}else{
			if( new_qty == parseInt(min) ){
				$('#quantity_modal .decrement-button').prop("disabled", true);
			}else{
				$('#quantity_modal .decrement-button').prop("disabled", false);	
			}
			$('#quantity_modal .control-number input').val(new_qty);	
			$('#quantity_modal .modal-footer .save-button').attr('data-quantity', new_qty);
		}
	});*/

	/* click save new quantity */
	/*$('body').on('click', '#quantity_modal .save-button', function(e){
		e.preventDefault();
		var csrf_token = $('meta[name="csrf-token"]').attr('content'); // Get csrf token
		var cart_id = $('#quantity_modal .modal-footer .save-button').attr('data-id');
		var qty = $('#quantity_modal .modal-footer .save-button').attr('data-quantity');
		var sku = $('#quantity_modal .modal-footer .save-button').attr('data-sku');
		var storage_domain_url = $(this).attr('data-domain');		
		console.log(cart_id,qty,sku, storage_domain_url);
		localStorage.setItem('storage_domain_url', storage_domain_url);
		var data = {
			'cart_index' : cart_id,
			'quantity': qty,
			'sku': sku,
			'_token': csrf_token,
		};
		console.log(cart_id,qty,sku, storage_domain_url, data);
		// $.post("/cart/add-item",data).done(function(data) {
		// 	addItemCart(data.cart);
		// }).fail(function(jqXHR, textStatus, errorThrown) {
		// 	console.log(jqXHR, textStatus, errorThrown);
		// });
	});*/

	$('.carousel-nutrition').each(function() {
		var total = $(this).find('.carousel-item').length;
		var currentIndex = $(this).find('.carousel-item.active').index() + 1;
		$(this).find('.slide-text').html(currentIndex + ' / '  + total);

		// This triggers after each slide change
		$(this).on('slid.bs.carousel', function () {
			currentIndex = $(this).find('.carousel-item.active').index() + 1;
			$(this).find('.slide-text').html(currentIndex + ' / ' + total);
		});
	});
	
	function ajaxPostcodeStoreSearch(search_string, order_type) {
        if (search_string.length > 2) {
            $.post('/get-stores-by-search', {
                store_location: search_string,
                order_type: order_type,
                _token: $('meta[name="csrf-token"]').attr('content')
            }).done(function(data) {
                var options = '<option value="">-</option>';
                $.each(JSON.parse(data.data), function(key, value){
                    options += '<option value="'+value.store_code+'" data-address="'+value.store_address+'" data-postcode="'+value.postcode+'">'+value.store_name+'</option>';
                });
                $('select#store').html(options);
                $('select#store').removeAttr('disabled');
            }).fail(function(jqXHR, textStatus, errorThrown) {
                $('select#store').removeAttr('disabled');
            });
        } 
    }
	$('body').on('click', '.postcode-search', function(e) {
        e.preventDefault();
        search_string = $('#address_search').val();
        order_type = $('#order_type').val();
        ajaxPostcodeStoreSearch(search_string, order_type);
    });	
    $('body').on('change', '#store', function(e) {
        e.preventDefault();
        postcode = $(this).find(':selected').attr('data-postcode');
        address = $(this).find(':selected').attr('data-address');
       	$('#postcode_text').val(postcode);
       	$('#postcode').val(postcode);
       	$('#address_text').val(address);
       	$('#address').val(address);
    });
});